import React, { Component } from 'react';

class GallerySideInfo extends Component {

  render() { 
    const { additionalInfo, hours } = this.props.galleryData;

    let dailyHoursObj = {};
    if (hours) dailyHoursObj = hours.days;
    const DAY_ORDER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const isDayOpen = (dayData) =>
      dayData && dayData.open && dayData.close && String(dayData.open).toLowerCase() !== 'closed';
    const openDaysOrdered = dailyHoursObj
      ? DAY_ORDER.filter((day) => dailyHoursObj[day] && isDayOpen(dailyHoursObj[day]))
      : [];

    return ( 
      <div className="aboutCart-sideInfo">
        <div className="aboutCart-sideInfo-hours">

          { hours && hours.heading &&  <h4>{hours.heading}</h4> }

          { openDaysOrdered.map((day) => (
                <div key={day}>{day}&nbsp; | &nbsp; {dailyHoursObj[day].open} to {dailyHoursObj[day].close}</div>
              ))
          }

          { hours && hours.heading && <p className='smallText'>Closed on all major holidays.</p>}
        </div>

        { additionalInfo && 
            <React.Fragment>
              <h4>{additionalInfo.heading}</h4>
              <p>{additionalInfo.text}</p>
            </React.Fragment>
        }
      </div>
    );
  }
}

export default GallerySideInfo;